import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

// Action Types
export const KEYSTONE_EVENT_SET_CLIENT_USAGE = 'KEYSTONE_EVENT/SET_CLIENT_USAGE';
export const SHOW_LOADING_SPINNER = 'KEYSTONE_EVENT/SHOW_LOADING_SPINNER';

// Action Creator
const KeystoneEventActionCreator = {
  setClientUsageData(params: any): TAction<any> {
    return {
      type: KEYSTONE_EVENT_SET_CLIENT_USAGE,
      payload: params
    };
  },

  showLoadingSpinner(show: boolean): TAction<boolean> {
    return {
      type: SHOW_LOADING_SPINNER,
      payload: show
    };
  }
};

export default KeystoneEventActionCreator;
